import React from 'react';
import {Redirect} from 'react-router-dom';

import {createRoutes} from '../@crema/utility/Utils';
import {authRouteConfig} from './auth';
import {initialUrl} from '../shared/constants/AppConst';
import { patientSettingsConfig } from './patient/Settings';
import { billingsPaymentsConfig } from './patient/BillingsPayments';
import { appointmentConfig } from './patient/Appointments';
import { errorPagesConfigs } from './errorPages';
import { medicalRecordsConfig } from './patient/MedicalRecords';
import { consultationConfig } from './patient/Consultation';
import { communicationConfig } from './patient/Communication';
import { dashboardConfig } from './patient/Dashboard';
import { therapyTasksConfig } from './patient/TherapyTasks';
import { signpostingConfig } from './patient/Signposting';
import {helpSupportConfig } from './patient/HelpSupport';
import { selfHelpConfig } from './patient/SelfHelp';
import { clinicalDocumentConfig } from './patient/ClinicalDocument';
import { otherTaskConfig } from './patient/OtherTasks';

const routeConfigs = [
  ...authRouteConfig,
  ...patientSettingsConfig,
  ...billingsPaymentsConfig,
  ...appointmentConfig,
  ...errorPagesConfigs,
  ...medicalRecordsConfig,
  ...consultationConfig,
  ...communicationConfig,
  ...dashboardConfig,
  ...therapyTasksConfig,
  ...signpostingConfig,
  ...helpSupportConfig,
  ...selfHelpConfig,
  ...clinicalDocumentConfig,
  ...otherTaskConfig
];

const routes = [
  ...createRoutes(routeConfigs),
  {
    path: '/',
    exact: true,
    component: () => <Redirect to={initialUrl} />,
  },
];

export default routes;
